import { CookieService } from 'ngx-cookie-service';
import { ToastService } from './../../services/toast.service';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import {
  LoadingController,
  AlertController,
  MenuController,
} from '@ionic/angular';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  loginForm: FormGroup;
  showWarning: boolean = false;
  year = new Date().getFullYear();
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private alertCtrl: AlertController,
    private userService: UserService,
    private alertService: AlertService,
    private menuCtrl: MenuController,
    private toastService: ToastService,
    private cookieService: CookieService
  ) {}

  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      password: new FormControl(
        '',
        Validators.compose([Validators.minLength(6), Validators.required])
      ),
    });
  }

  async handleLoginUser() {
    if (this.loginForm.valid) {
      this.showWarning = false;
      this.loadingCtrl
        .create({ keyboardClose: true, cssClass: 'loading-ctrl' })
        .then((loadingEl) => {
          loadingEl.present();
          let userDetails = {
            email: this.loginForm.value.email,
            password: this.loginForm.value.password,
          };
          this.authService.loginUser(userDetails).then(
            (data) => {
              this.userService.getUserDetailsById(data.user.uid).subscribe(
                (res: any) => {
                  //If the users data is successfully loaded
                  loadingEl.dismiss();
                  if (res &&  res.isAdmin == 'true') {
                    // He is an admin
                    loadingEl.dismiss();
                    this.cookieService.set('email', this.loginForm.value.email, 1);
                    this.router.navigate(['/classes'], { replaceUrl: true });
                  } else {
                    // He is not an admin

                    // I am signing him out
                    this.authService.logoutUser();
                    // Showing an error that he is not a user
                    this.alertService.showAlert(
                      'Error',
                      'Only admins can login',
                      ['Okay']
                    );
                  }
                },
                (err) => {
                  // If the users data is unseuccessfull (Inbternet issues or db issues)
                  // I am hiding the loader
                  loadingEl.dismiss();
                  // Showing what went wrong
                  this.alertService.showFirebaseAlert(err);
                }
              );
            },
            async (err) => {
              loadingEl.dismiss();
              const alert = await this.alertCtrl.create({
                header: 'Error',
                message: err.message,
                buttons: ['Okay'],
              });
              await alert.present();
            }
          );
        });
    } else {
      this.showWarning = true;
    }
  }

  goToLink() {
    window.open('https://www.linkedin.com/in/rasheek/', '_blank');
  }
}
